export default __webpack_public_path__ + "static/heroku-festive-9780f9ebfaedfc749a8e1e199515e3ae.gif";